import pino from 'pino';

const metaInformation = {
    name: 'main-logger',
    appName: 'zoopla-website',
    environment: process.env.NODE_ENV
};

const pinoPretty = {
    transport: {
        target: 'pino-pretty'
    }
};

const simpleLogs = {
    formatters: {
        level(level: string) {
            return { level };
        },
        bindings() {
            return {};
        },
        log() {
            return {};
        }
    }
};

const pinoLogger = pino({
    enabled: !(process.env.LOG_ENABLED === 'false'),
    mixin() {
        return metaInformation;
    },
    timestamp: process.env.SIMPLE_LOGS === 'true' ? false : true,
    ...(process.env.PRETTY_LOGS === 'true' ? pinoPretty : {}),
    ...(process.env.SIMPLE_LOGS === 'true' ? simpleLogs : {})
});

// TODO o11y: dynamically create these types based off of the codeowners file
type Custodians =
    | 'platform'
    | 'sell'
    | 'pnp'
    | 'home'
    | 'search'
    | 'commercial';

export type LoggerMetaData = {
    page?: string;
    component?: string;
    custodian: Custodians;
    [key: string]: string | number | undefined | Custodians;
} & ({ page: string } | { component: string });

export const setupLogger = (metaData: LoggerMetaData) => {
    return pinoLogger.child(metaData);
};
